import React from 'react';
import { Col, Skeleton } from 'antd';

export const SkeletonLoading: React.FC = () => {
  return (
    <Col
      xs={24}
      sm={24}
      md={14}
      lg={10}
      xl={10}
      className="chat-loading-skeleton"
      style={{ padding: '20px' }}
    >
      <Skeleton active avatar paragraph={{ rows: 1 }} />
      <Skeleton active avatar paragraph={{ rows: 1 }} />
      <Skeleton active avatar paragraph={{ rows: 1 }} />
      <Skeleton active avatar paragraph={{ rows: 1 }} />
    </Col>
  );
};

export const OrdersLoading: React.FC = () => {
  return (
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={24}
      xl={24}
      className="chat-loading-skeleton"
      style={{ padding: '20px' }}
    >
      <Skeleton active avatar paragraph={{ rows: 1 }} />
      <Skeleton active avatar paragraph={{ rows: 1 }} />
      <Skeleton active avatar paragraph={{ rows: 1 }} />
      <Skeleton active avatar paragraph={{ rows: 1 }} />
    </Col>
  );
};